import React from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
export function Proof() {
  const timeline = [{
    day: 'Day 3',
    desc: "Most women report the 'tight chest' feeling disappearing."
  }, {
    day: 'Day 5',
    desc: "The 11 PM 'second wind' is replaced by a natural, heavy sleepiness."
  }, {
    day: 'Day 7',
    desc: "You wake up before your alarm feeling actually rested, not just 'functional.'"
  }];
  return <section className="bg-navy-900 text-cream-100 py-24 px-6 relative overflow-hidden" data-id="element-141">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-142">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-143">
          <path d="M0,20 Q50,80 100,20" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-144" />
          <path d="M0,30 Q50,90 100,30" fill="none" stroke="#c9a96e" strokeWidth="0.5" data-id="element-145" />
        </svg>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-147">
          <span className="text-gold-500 font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-148">
            The Timeline
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream-50 mb-6" data-id="element-149">
            What Changes in 7 Days?
          </h2>
        </motion.div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gold-500/30 before:to-transparent" data-id="element-150">
          {timeline.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-151">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-gold-500 bg-navy-800 text-gold-500 shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_15px_rgba(201,169,110,0.2)] z-10" data-id="element-152">
                <Calendar size={18} data-id="element-153" />
              </div>

              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] bg-navy-800/50 backdrop-blur-sm border border-gold-500/20 p-6 rounded-2xl shadow-lg" data-id="element-154">
                <h3 className="font-serif text-2xl text-gold-400 mb-3" data-id="element-155">
                  {item.day}
                </h3>
                <p className="text-cream-200 text-lg font-light leading-relaxed" data-id="element-156">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}